import { filterObjectKeys } from '../components/utils'

const initialState = {
    data: null,
    experience: null,
    photo: null,
    resume: null,
    errorModal: false,
    errors: {},
    experience_errors: {},
    additional_city_errors: {},
    photo_upload_progress: null,
    resume_upload_progress: null,
}

function handleOnboardingStepComplete(state, action) {
    // Take a copy of the current data
    const data = { ...state.data }

    // Calculate the key for this onboarding step
    const onboardingStepKey = `${ action.step }_complete`

    // Set that key to true in the new data
    data[onboardingStepKey] = true

    // Now see whether the whole onboarding is complete
    data.onboarding_complete =
        data.ica_complete && data.personal_complete &&
        data.experience_complete && data.crew_positions_complete &&
        data.gear_primary_complete &&
        (data.crew_secondary_type_none === false ?
            data.gear_secondary_complete :
            true
        ) &&
        (data.crew_tertiary_type_none === false ?
            data.gear_tertiary_complete :
            true
        )

    return {
        ...state,
        data,
    }
}

function handleLoadPersonalSuccess(state, action) {
    let photo = null

    if (action.data.photo) {
        photo = { photo: action.data.photo }
    }

    return {
        ...state,
        data: action.data,
        photo,
    }
}

function handleSubmitAdditionalCitySuccess(state, action) {
    const newItems = []

    let found = false

    // go through each item in the current state and, if it matches the data being passed
    // in, replace it, otherwise, just add it as normal
    if (state.data.additional_cities) {
        for (let item of state.data.additional_cities) {
            if (item.uuid === action.data.uuid) {
                item = action.data
                found = true
            }

            newItems.push(item)
        }
    }

    // if we didn't find the item in the current state, it's new, so add it to the end
    if (! found) {
        newItems.push(action.data)
    }

    return {
        ...state,
        data: {
            ...state.data,
            additional_cities: newItems,
        },
        additional_city_errors: {},
    }
}

function handleLoadExperienceSuccess(state, action) {
    let resume = null

    if (action.data.resume) {
        resume = { resume: action.data.resume }
    }

    return {
        ...state,
        experience: action.data,
        resume,
    }
}

export default function personal(state = initialState, action) {
    switch (action.type) {
        case 'SIGN_OUT':
            return initialState

        case 'ONBOARDING_STEP_COMPLETE':
            return handleOnboardingStepComplete(state, action)

        // Payment details update (technically out of this reducer's jurisdiction, but y'know,
        // cross-cutting concerns...)
        // case 'LOAD_PAYMENT_DETAILS_SUCCESS':
        // case 'SUBMIT_PAYMENT_DETAILS_SUCCESS':
        //     return {
        //         ...state,
        //         data: {
        //             ...state.data,
        //             stripe_connect_account_id: action.data.stripe_connect_account_id,
        //         },
        //     }

        // Loading of personal data
        case 'LOAD_PERSONAL_SUCCESS':
            return handleLoadPersonalSuccess(state, action)

        case 'LOAD_PERSONAL_ERROR':
            return {
                ...state,
                errors: action.errors || {},
            }

        // Patching of personal data
        case 'PATCH_PERSONAL_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.data,
                },
                errors: filterObjectKeys(state.errors || {}, Object.keys(action.data), 'exclude'),
                errorModal: false,
            }

        case 'PATCH_PERSONAL_ERROR':
            return {
                ...state,
                errors: action.errors || {},
                errorModal: false,
            }

        // Submission of personal data
        case 'SUBMIT_PERSONAL_SUCCESS':
            return {
                ...state,
                data: action.data,
                errors: {},
            }
        case 'SUBMIT_PERSONAL_ERROR':
            return {
                ...state,
                errors: action.errors || {},
                errorModal: Date.now(),
            }

        // Add/update additional city
        case 'SUBMIT_ADDITIONAL_CITY_SUCCESS':
            return handleSubmitAdditionalCitySuccess(state, action)

        case 'SUBMIT_ADDITIONAL_CITY_ERROR':
            return {
                ...state,
                additional_city_errors: action.errors || {},
            }

        // Delete additional city
        case 'DELETE_ADDITIONAL_CITY_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,

                    // take current list from current state and filter out the deleted one
                    additional_cities: state.data.additional_cities.filter(
                        (item) => (item.uuid !== action.data.uuid)
                    ),
                },
                additional_city_errors: {},
            }

        // Loading of experience data
        case 'LOAD_EXPERIENCE_SUCCESS':
            return handleLoadExperienceSuccess(state, action)

        case 'LOAD_EXPERIENCE_ERROR':
            return {
                ...state,
                experience_errors: action.errors || {},
            }

        // Patching of experience data
        case 'PATCH_EXPERIENCE_SUCCESS':
            return {
                ...state,
                experience: {
                    ...state.experience,
                    ...action.data,
                },
                experience_errors: filterObjectKeys(state.experience_errors || {}, Object.keys(action.data), 'exclude'),
                errorModal: false,
            }

        case 'PATCH_EXPERIENCE_ERROR':
            return {
                ...state,
                experience_errors: action.errors || {},
                errorModal: false,
            }

        // Submission of experience data
        case 'SUBMIT_EXPERIENCE_SUCCESS':
            return {
                ...state,
                experience: action.data,
                experience_errors: {},
            }
        case 'SUBMIT_EXPERIENCE_ERROR':
            return {
                ...state,
                experience_errors: action.errors || {},
                errorModal: Date.now(),
            }

        // Submission of crew positions
        case 'UPDATE_CREW_POSITIONS_SUCCESS':
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.data,
                },
                errors: {},
            }
        case 'UPDATE_CREW_POSITIONS_ERROR':
            return {
                ...state,
                errors: action.errors || {},
            }

        // Upload of personal photo
        case 'UPLOAD_PHOTO_SUCCESS':
            return {
                ...state,
                photo: action.data,
                photo_uploadProgress: null,
                errors: {
                    ...state.errors,
                    photo: null,
                },
            }
        case 'UPLOAD_PHOTO_ERROR':
            return {
                ...state,
                photo_uploadProgress: null,
                errors: {
                    ...state.errors,
                    ...action.errors,
                },
            }
        case 'UPLOAD_PHOTO_PROGRESS':
            return {
                ...state,
                photo_upload_progress: action.percent,
            }

        // Upload of resume
        case 'UPLOAD_RESUME_SUCCESS':
            return {
                ...state,
                resume: action.data,
                resume_upload_progress: null,
                experience_errors: {
                    ...state.experience_errors,
                    resume: null,
                },
            }
        case 'UPLOAD_RESUME_ERROR':
            return {
                ...state,
                resume_upload_progress: null,
                experience_errors: {
                    ...state.experience_errors,
                    ...action.errors,
                },
            }
        case 'UPLOAD_RESUME_PROGRESS':
            return {
                ...state,
                resume_upload_progress: action.percent,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/personal.js